import { DefaultState } from 'store/types';
import { SetDefaultReservationProviderState, SetDefaultReservationProviderActionTypes, SET_DEFAULT_RESERVATION_PROVIDER_REQUEST, SET_DEFAULT_RESERVATION_PROVIDER_SUCCESS, SET_DEFAULT_RESERVATION_PROVIDER_FAILURE } from './types';

const initialState: DefaultState = {
  isLoading: false,
  errorMessage: "",
};

export default function setDefaultReservationProviderReducer(state: SetDefaultReservationProviderState = initialState, action: SetDefaultReservationProviderActionTypes): SetDefaultReservationProviderState {
  switch (action.type) {
    case SET_DEFAULT_RESERVATION_PROVIDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        errorMessage: "",
      };
    case SET_DEFAULT_RESERVATION_PROVIDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contents: action.contents,
      };
    case SET_DEFAULT_RESERVATION_PROVIDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: "Failed to set default reservation provider",
      };
    default:
      return state;
  }
}